var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParseNewLines = exports.replaceNewlines = void 0;
const react_1 = __importDefault(require("react"));
const any_1 = require("../elements/any");
exports.replaceNewlines = (children) => {
    const result = [];
    react_1.default.Children.forEach(children, (child) => {
        if (child && typeof child === 'string') {
            result.push(child.split('\n').reduce((children, textSegment, index) => {
                return [...children, index > 0 && react_1.default.createElement("br", { key: index }), textSegment];
            }, []));
        }
        else if (child) {
            result.push(child);
        }
    });
    return result;
};
exports.ParseNewLines = (props) => {
    return (react_1.default.createElement(any_1.Any, { is: props.is, polyPreset: true, wheel: props.wheel }, exports.replaceNewlines(props.children)));
};
//# sourceMappingURL=parse-new-lines.js.map